module.exports = __webpack_public_path__ + "static/media/icon-diagram.cbb0294c.svg";